import { Component, ViewChild } from '@angular/core';

import { DeviceService } from '../../../core/services/device/device.service';
import { GtmService } from '../../../core/services/gtm/gtm.service';
import { WindowRefService } from '../../../core/services/windowRef/window-ref.service';
import { NETWORK_CONSTANTS } from '../../../lazy-modules/networkIndicator/components/network-indicator/network-indicator.constants';
import { LocaleDirective } from '../../directives/locale.directive';
import { ModalComponent } from '../customModal/custom-modal.component';
import { AbstractDialogComponent } from '../oxygenDialogs/abstract-dialog';

@Component({
    selector: 'connection-interruption-dialog',
    templateUrl: './connection-interruption-dialog.component.html',
    styleUrls: ['./connection-interruption-dialog.component.scss'],
    imports: [ModalComponent, LocaleDirective],
})
export class ConnectionInterruptionDialogComponent extends AbstractDialogComponent {
    @ViewChild('connectionInterruptionDialog', { static: true }) override dialog: any;

    constructor(
        device: DeviceService,
        windowRef: WindowRefService,
        private gtmService: GtmService,
    ) {
        super(device, windowRef);
    }

    closeInterruptionPopup(): void {
        this.gtmService.push(NETWORK_CONSTANTS.GA_TAGS.EVENT_TRACKING, [
            {
                ...NETWORK_CONSTANTS.GA_STATIC_FIELDS,
                'component.ActionEvent': NETWORK_CONSTANTS.GA_TAGS.CLICK,
                'component.PositionEvent': NETWORK_CONSTANTS.GA_TAGS.TOP,
                'component.LocationEvent': NETWORK_CONSTANTS.GA_TAGS.NA,
                'component.EventDetails': NETWORK_CONSTANTS.GA_TAGS.OK_CTA,
            },
        ]);
        super.closeDialog();
    }
}
